export default __webpack_public_path__ + "img/41ed22c28561c905f33e9c83350ac553.png";